<template>
    <section class="growth">
        <div class='title'>
            <span>平台：</span>
            <span>{{pname}}</span>
            
        </div>

        <div class='title'>
            <span>客机ID：</span>
            <span>{{id}}</span>
            
        </div>

        <div class='title'>
            <span>客机名称：</span>
            <span>{{name}}</span>
            
        </div>

        <div class="to-button" @click='bindSubmit()'>
            绑定
        </div>
    </section>
</template>

<script>
    import myApi from '@/axios/my'
    import { Dialog,Toast } from 'vant';
    export default {
    name: 'bindUinId',
    data () {
      return {
          id : this.$route.query.id,
          name : this.$route.query.name,
          pname : this.$route.query.pname,
      }
    },
    component: {
    
    },
    watch: {},
    computed: {

    },
    created () {
     
    },
    mounted () {

    },
    methods: {
        bindSubmit(){
            Dialog.confirm({
                title: '提示',
                message: '是否检查仔细确认绑定？',
            }).then(() => {
            // on confirm
                let params = {
                    uin : localStorage.getItem('unionId'),
                    id : this.id,
                }
                myApi.bindServicePhone(params).then(()=>{
                    Toast('绑定成功');
                    setTimeout(()=>{
                        this.$router.push({name:'growth'})
                    },2000)
                })
            }).catch(() => {
            // on cancel
            });
         
        }
    }
  }
</script>

<style lang="scss" scoped>
    .to-button{
        // width: 7rem;
        margin-top: 100px;
        height: 1rem;
        z-index: 10;
        // background: url(/images/activity/sixbtn.png) no-repeat;
        // background-size: 100%;
        background: #333333;
        border-radius:0.8rem;
        font-size: 30px;
        line-height: 1rem;
        text-align: center;
        color:#fff;
    }
    .growth{
        background: #fff;
        height: 100vh;
        padding: 36px;
        .card{
            background: #fff;
            border-radius:30px;
            min-height: 500px;
            margin-top: 36px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .card_item{
                display: flex;
                margin-left: 1%;
                width: 30%;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 28px;
                font-weight: 500;
                height: 200px;
                .img_path{
                    width: 84px;
                    height: 84px;
                    margin-bottom: 20px;
                }
            }
        }
        .title{
            font-size: 28px;
            color: #333333;
            line-height: 90px;
            display: flex;
            font-weight:500;
            align-items: center;
            span{
                position: relative;
                top:5px;
            }
            .tips{
                width: 82px;
                height: 82px;
                border-radius:41px; 
                margin-right: 20px;
            }
        }
    }

</style>
